import moment from "moment";

/**
 * Formatação e erros comuns às abas do Relatórios que usam o kyojin
 * (Compras, Análise de Preço, Ordem de compras).
 */
export default {
  methods: {
    filterOption(input, option) {
      const text = option.componentOptions.children[0].text || "";
      return text.toLowerCase().includes(input.toLowerCase());
    },
    formatDate(value) {
      return value ? moment(String(value)).format("DD/MM/YYYY") : "--";
    },
    brl(value) {
      return Number(value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
    num(value) {
      return Number(value || 0).toLocaleString("pt-BR", { maximumFractionDigits: 2 });
    },
    int(value) {
      return Number(value || 0).toLocaleString("pt-BR");
    },
    pct(value) {
      if (value === null || value === undefined) return "--";
      return `${Number(value).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;
    },
    /** 422 do kyojin vira a mensagem do campo; o resto, a mensagem padrão da aba. */
    notifyError(error, fallback = "Não foi possível carregar o relatório.") {
      const data = error && error.response ? error.response.data : null;
      const fieldErrors = data && data.errors && !Array.isArray(data.errors) ? Object.values(data.errors)[0] : null;
      const message = (fieldErrors && fieldErrors[0]) || (data && data.message) || fallback;
      this.$store.dispatch("notification/add", { type: "error", message });
    },
    /** Baixa a resposta blob de um export=xlsx. */
    downloadBlob(data, filename) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
  },
};
